module.exports = __webpack_public_path__ + "static/media/logoPoweredBy.e6533054.png";